import superagent from "superagent";
import EventBus from "@/utils/EventBus";
import Events from "@/utils/Events";
import InputLock from "@/utils/InputLock";
export class CordovaRq{

}
class Client {
    constructor() {
        this.lockNext = false;
        this.locked = false;
        this.currentLockLocation = "";
        this.pendingLock = null;
    }

    interceptReq(req){
        if(this.lockNext){
            let lock;
            if(!this.pendingLock ){
                this.currentLockLocation = window.location.href;
                lock = new InputLock();
                lock.lock();
                this.locked = true;
                this.pendingLock = lock;
                Log.trace("Locking input")
            } else {
                lock = this.pendingLock;
            }

            req.on("end", () =>{
                Log.trace("Req end detected; releasing input");
                this.locked = false;
                this.pendingLock = null;
                lock.release();
            });
        }

        this.lockNext = false;
    }

    lockToNextRequestEnd() {
        if(this.lockNext) {
            if (this.currentLockLocation != window.location.href) {
                Log.debug("Looks like previous lock wasn't cleared; overwriting");
                this.lockNext = true;
                this.pendingLock = null;
            }
        }

        this.currentLockLocation = window.location.href;
        let lock = new InputLock();
        lock.lock();
        this.locked = true;
        this.pendingLock = lock;
        Log.trace("Locking input")

        this.lockNext = true;
    }

    lockDuringNextRequest() {
        if(this.lockNext){
            if(this.currentLockLocation != window.location.href){
                Log.debug("Looks like previous lock wasn't cleared; overwriting");
                this.lockNext = true;
                this.pendingLock = null;
            }

            Log.debug("Lock already requested - ignoring");
            return;
        }

        if(this.locked){
            Log.debug("Already locked - ignoring");
            return;
        }

        this.lockNext = true;
    }

    async doGet(relativeUri, params){
        let req = superagent.get(relativeUri).
            set("Content-Type", "application/json").
            set("Accept", "application/json");
        if(params !== undefined){
            let query = "";
            req.query(params);
        }
        this.interceptReq(req);
        let response = await req.send();

        return this.processResponse(response);
    }

    async doPost(relativeUri, dataJson){
        let dataJsonString = JSON.stringify(dataJson);
        let req = superagent.post(relativeUri).
            set("Content-Type", "application/json").
            set("Accept", "application/json");
        this.interceptReq(req);
        let response;
        if(dataJsonString !== null && dataJsonString !== undefined){
            response = await req.send(dataJsonString);
        } else {
            response = await req.send();
        }
        return this.processResponse(response);
    }

    processResponse(response) {
        if(response.status !== 200){
            if(response.status !== 401){
                EventBus.$emit(Events.sessionBroken, response);
            }
            EventBus.$emit(Events.apiError, response);
            throw Events.apiError;
        }
        return response.body.result;
    }

    /**
     * @returns {Promise<PreValidateOutput>}
     */
    async preValidate(organization, login, email, password){
        return this.doPost("/api/user/pre-validate", {organization, login, email, password});
    }

    /**
     * @returns {Promise<ApplicationUser>}
     */
    async signUp(organization, email, password, captchaToken){
        return this.doPost("/api/user/sign-up", {organization, email, password, captchaToken});
    }

    /**
     * @returns {Promise<ApplicationUser>}
     */
    async signUpUser(login, email, firstName, lastName, password){
        return this.doPost("/api/user/sign-up-user", {login, email, firstName, lastName, password});
    }


    /**
     * @returns {Promise<ApplicationUser>}
     */
    async signIn(organization, email, password){
        return this.doPost("/api/user/sign-in", {organization, email, password});
    }

    /**
     * @returns {Promise<*>}
     */
    async signOut(){
        return this.doGet("/api/user/sign-out");
    }


}

const instance = new Client();
export default instance;